import { render, staticRenderFns } from "./lawsuit.vue?vue&type=template&id=edc23608&scoped=true"
import script from "./lawsuit.vue?vue&type=script&lang=js"
export * from "./lawsuit.vue?vue&type=script&lang=js"
import style0 from "./lawsuit.vue?vue&type=style&index=0&id=edc23608&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc23608",
  null
  
)

export default component.exports